module.exports = __webpack_public_path__ + "img/avatar-point.677cd212.webp";